const LOWERCASE = 'abcdefghijkmnopqrstuvwxyz';
const UPPERCASE = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const NUMBERS = '23456789';
const SYMBOLS = '!@#$%&*?';
const ALL_PASSWORD_CHARACTERS = `${LOWERCASE}${UPPERCASE}${NUMBERS}${SYMBOLS}`;

const randomInteger = (maximum) => {
  const cryptoApi = typeof window !== 'undefined' ? window.crypto : undefined;
  if (cryptoApi?.getRandomValues) {
    const values = new Uint32Array(1);
    cryptoApi.getRandomValues(values);
    return values[0] % maximum;
  }

  return Math.floor(Math.random() * maximum);
};

const randomCharacter = (characters) => characters[randomInteger(characters.length)];

export const generateTemporaryPassword = (length = 14) => {
  const characters = [
    randomCharacter(LOWERCASE),
    randomCharacter(UPPERCASE),
    randomCharacter(NUMBERS),
    randomCharacter(SYMBOLS),
  ];

  while (characters.length < Math.max(8, length)) {
    characters.push(randomCharacter(ALL_PASSWORD_CHARACTERS));
  }

  for (let index = characters.length - 1; index > 0; index -= 1) {
    const target = randomInteger(index + 1);
    [characters[index], characters[target]] = [characters[target], characters[index]];
  }

  return characters.join('');
};

const emailPart = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .trim()
  .replace(/[^a-z0-9]+/g, '.')
  .replace(/^\.+|\.+$/g, '');

export const suggestUserEmail = (firstName, lastName) => {
  const localPart = [emailPart(firstName), emailPart(lastName)].filter(Boolean).join('.');
  return localPart ? `${localPart}@cliente.com` : '';
};
